// This file is auto-generated by @hey-api/openapi-ts

import * as v from 'valibot';

/**
 * The error response.
 */
export const vErrorResponse = v.object({
  code: v.string(),
  message: v.string(),
});

/**
 * Claims about the user.
 */
export const vUserClaims = v.object({
  sub: v.string(),
  email: v.optional(v.string()),
  iss: v.string(),
  uat: v.optional(v.pipe(v.number(), v.integer())),
});

/**
 * The subscription response. The client has to use this information to connect using wss protocol
 */
export const vNotificationSubscribeResponse = v.object({
  url: v.string(),
});

/**
 * The library descriptor
 */
export const vLibraryResponse = v.object({
  id: v.string(),
  createdAt: v.pipe(v.string(), v.isoTimestamp()),
  createdBy: v.string(),
  modifiedAt: v.pipe(v.string(), v.isoTimestamp()),
  modifiedBy: v.string(),
  deleted: v.optional(v.boolean()),
  v: v.pipe(v.number(), v.integer()),
  name: v.optional(v.string()),
  description: v.optional(v.string()),
  policy: v.optional(v.record(v.string(), v.unknown())),
  _actions: v.optional(v.array(v.string())),
});

/**
 * The pset definition identity.
 */
export const vLibraryIdentity = v.object({
  libId: v.string(),
});

/**
 * The pset definition/version identifier.
 */
export const vDefinitionIdentity = v.object({
  id: v.string(),
  v: v.optional(v.pipe(v.number(), v.integer())),
  schemaV: v.optional(v.pipe(v.number(), v.integer())),
});

/**
 * A list of pset definition keys.
 */
export const vDefinitionIdentityList = v.object({
  items: v.optional(v.array(vDefinitionIdentity)),
});

/**
 * The pset definition identity.
 */
export const vDefinitionIdentityV2 = v.object({
  libId: v.string(),
  defId: v.string(),
  v: v.optional(v.pipe(v.number(), v.integer())),
  schemaV: v.optional(v.pipe(v.number(), v.integer())),
});

/**
 * The pset schema.
 *
 * The pset schema that describes all possible properties in the pset. Please refer to the pset schema specification https://drive.google.com/open?id=1sDVdKpLesdnxzU6-KQuaGRWmMSO9DGrS.
 */
export const vPSetSchemaRequest = v.object({
  open: v.optional(v.boolean()),
  props: v.record(v.string(), v.unknown()),
});

/**
 * The pset definition creation request.
 */
export const vCreatePSetDefRequest = v.object({
  id: v.optional(v.string()),
  name: v.optional(v.string()),
  description: v.optional(v.string()),
  types: v.optional(v.array(v.string())),
  schema: vPSetSchemaRequest,
  i18n: v.optional(v.record(v.string(), v.unknown())),
});

/**
 * The library creation request
 */
export const vCreateLibraryRequest = v.object({
  id: v.optional(v.string()),
  policy: v.optional(v.record(v.string(), v.unknown())),
  name: v.optional(v.string()),
  description: v.optional(v.string()),
  defs: v.optional(v.array(vCreatePSetDefRequest)),
});

/**
 * The pset definition update or create request.
 *
 * If schema property is sent in the requested service will increment the schema version. The client should take care not to send this property when it does not want the schema version to be incremented.
 */
export const vUpsertPSetDefRequest = v.object({
  v: v.optional(v.pipe(v.number(), v.integer())),
  name: v.optional(v.string()),
  description: v.optional(v.string()),
  types: v.optional(v.array(v.string())),
  schema: v.optional(vPSetSchemaRequest),
  i18n: v.optional(v.record(v.string(), v.unknown())),
});

/**
 * The operation to apply to pset definition in incremental (delta) mode.
 *
 * The operation to apply to pset definition in incremental (delta) mode. The operation could be inserted, update, upsert, or delete. If schema property is sent in the requested service will increment the schema version. The client should take care not to send this property when it does not want the schema version to be incremented.
 */
export const vChangePSetDefRequest = v.object({
  id: v.optional(v.pipe(v.number(), v.integer())),
  v: v.optional(v.pipe(v.number(), v.integer())),
  deleted: v.optional(v.boolean()),
  name: v.optional(v.string()),
  description: v.optional(v.string()),
  types: v.optional(v.array(v.string())),
  schema: v.optional(vPSetSchemaRequest),
  i18n: v.optional(v.record(v.string(), v.unknown())),
});

/**
 * The library update or create request
 */
export const vUpsertLibraryRequest = v.object({
  v: v.optional(v.pipe(v.number(), v.integer())),
  policy: v.optional(v.record(v.string(), v.unknown())),
  name: v.optional(v.string()),
  description: v.optional(v.string()),
  defs: v.optional(v.array(vChangePSetDefRequest)),
  'defs.delta': v.optional(v.array(vChangePSetDefRequest)),
});

/**
 * The unprocessed create definition request with error.
 */
export const vUnprocessedChangePSetDefRequest = v.object({
  item: v.optional(vChangePSetDefRequest),
  code: v.string(),
  message: v.string(),
});

/**
 * The pset schema.
 *
 * The pset schema that describes all possible properties in the pset. Please refer to the pset schema specification https://drive.google.com/open?id=1sDVdKpLesdnxzU6-KQuaGRWmMSO9DGrS.
 */
export const vPSetSchemaResponse = v.object({
  open: v.optional(v.boolean()),
  v: v.pipe(v.number(), v.integer()),
  props: v.record(v.string(), v.unknown()),
});

/**
 * The pset definition.
 */
export const vDefinitionResponse = v.object({
  id: v.string(),
  libId: v.string(),
  createdAt: v.pipe(v.string(), v.isoTimestamp()),
  createdBy: v.string(),
  modifiedAt: v.pipe(v.string(), v.isoTimestamp()),
  modifiedBy: v.string(),
  deleted: v.optional(v.boolean()),
  v: v.pipe(v.number(), v.integer()),
  name: v.optional(v.string()),
  description: v.optional(v.string()),
  types: v.optional(v.array(v.string())),
  schema: vPSetSchemaResponse,
  i18n: v.optional(v.record(v.string(), v.unknown())),
  _actions: v.optional(v.array(v.string())),
});

/**
 * The created or updated library descriptor
 *
 * The library descriptor returned from the `CreateLibrary` or `UpsertLibrary` APIs. Might include the collection of deep definitions operations if were requested. If some definitions operations failed with errors or because of throttling they are returned in `defs.unprocessed` collection with error codes.
 */
export const vUpsertLibraryResponse = v.object({
  id: v.string(),
  createdAt: v.pipe(v.string(), v.isoTimestamp()),
  createdBy: v.string(),
  modifiedAt: v.pipe(v.string(), v.isoTimestamp()),
  modifiedBy: v.string(),
  deleted: v.optional(v.boolean()),
  v: v.pipe(v.number(), v.integer()),
  name: v.optional(v.string()),
  description: v.optional(v.string()),
  defs: v.optional(v.array(vDefinitionResponse)),
  'defs.unprocessed': v.optional(v.array(vUnprocessedChangePSetDefRequest)),
  policy: v.optional(v.record(v.string(), v.unknown())),
  _actions: v.optional(v.array(v.string())),
});

/**
 * The page with a list of pset definitions and a link to the next page.
 */
export const vPSetDefsPage = v.object({
  items: v.array(vDefinitionResponse),
  next: v.optional(v.string()),
});

/**
 * A error descriptor from the batch get pset API.
 */
export const vBatchGetDefinitionsError = v.object({
  code: v.string(),
  message: v.string(),
  item: vDefinitionIdentity,
});

/**
 * The response from batch get pset definitions API. A list of pset definitions and a list of unprocessed pset definition keys.
 */
export const vBatchGetDefinitionsResponse = v.object({
  items: v.array(vDefinitionResponse),
  unprocessed: v.array(vDefinitionIdentity),
  errors: v.array(vBatchGetDefinitionsError),
});

/**
 * The request to validate existing pset data against a new schema proposal.
 *
 * The request to validate existing pset data against a new schema proposal. The request structure is compatible with the definition update request by purpose.
 */
export const vValidationRequest = v.object({
  schema: vPSetSchemaRequest,
});

/**
 * The result (potentially partial) of the existing pset instances validation against a new proposed schema with the count of valid and not valid pset instances.
 */
export const vValidationResponsePage = v.object({
  validItemsCount: v.pipe(v.number(), v.integer()),
  invalidItemsCount: v.pipe(v.number(), v.integer()),
  errors: v.optional(v.array(v.string())),
  next: v.optional(v.string()),
});

/**
 * The pset instance create or update request.
 */
export const vUpdatePSetRequest = v.object({
  v: v.optional(v.pipe(v.number(), v.integer())),
  schemaV: v.optional(v.pipe(v.number(), v.integer())),
  props: v.record(v.string(), v.unknown()),
});

/**
 * The pset instance create, update or delete request.
 */
export const vChangePSetRequest = v.object({
  link: v.string(),
  libId: v.string(),
  defId: v.string(),
  v: v.optional(v.pipe(v.number(), v.integer())),
  schemaV: v.optional(v.pipe(v.number(), v.integer())),
  props: v.record(v.string(), v.unknown()),
  deleted: v.optional(v.boolean()),
});

/**
 * The pset instance.
 */
export const vPSetResponse = v.object({
  link: v.string(),
  libId: v.string(),
  defId: v.string(),
  createdAt: v.pipe(v.string(), v.isoTimestamp()),
  createdBy: v.string(),
  modifiedAt: v.pipe(v.string(), v.isoTimestamp()),
  modifiedBy: v.string(),
  deleted: v.optional(v.boolean()),
  v: v.pipe(v.number(), v.integer()),
  schemaV: v.pipe(v.number(), v.integer()),
  props: v.record(v.string(), v.unknown()),
  _actions: v.optional(v.array(v.string())),
});

/**
 * The pset instance key.
 */
export const vPSetIdentity = v.object({
  libId: v.string(),
  defId: v.string(),
  link: v.string(),
  v: v.optional(v.pipe(v.number(), v.integer())),
});

/**
 * The page with a list of psets and a link to the next page.
 */
export const vPSetsPage = v.object({
  items: v.array(vPSetResponse),
  next: v.optional(v.string()),
});

/**
 * The page with a list of psets and a link to the next page and changeToken in the last page.
 */
export const vSyncPSetsPage = v.object({
  items: v.array(vPSetResponse),
  next: v.optional(v.string()),
  changeToken: v.optional(v.string()),
});

/**
 * A list of pset keys.
 */
export const vPSetIdentityList = v.object({
  items: v.array(vPSetIdentity),
});

/**
 * A list of links.
 */
export const vLinkList = v.object({
  items: v.array(v.string()),
});

/**
 * A error descriptor from the batch get API for pset resource.
 */
export const vBatchGetPSetError = v.object({
  code: v.string(),
  message: v.string(),
  item: vPSetIdentity,
});

/**
 * The response from batch get psets API. A list of psets, errors and unprocessed pset identities.
 */
export const vBatchGetPSetsResponse = v.object({
  items: v.array(vPSetResponse),
  unprocessed: v.optional(v.array(vPSetIdentity)),
  errors: v.optional(v.array(vBatchGetPSetError)),
});

/**
 * A error descriptor from the batch get API for pset resource.
 */
export const vBatchGetPSetByDefError = v.object({
  code: v.string(),
  message: v.string(),
  item: v.string(),
});

/**
 * The response from batch get psets API. A list of psets, errors and unprocessed links.
 */
export const vBatchGetPSetsByDefResponse = v.object({
  items: v.array(vPSetResponse),
  unprocessed: v.optional(v.array(v.string())),
  errors: v.optional(v.array(vBatchGetPSetByDefError)),
});

/**
 * A error descriptor from the batch get API for library resource.
 */
export const vBatchGetLibraryError = v.object({
  code: v.string(),
  message: v.string(),
  item: vLibraryIdentity,
});

/**
 * A error descriptor from the batch get API for definition resource.
 */
export const vBatchGetDefinitionsV2Error = v.object({
  code: v.string(),
  message: v.string(),
  item: vDefinitionIdentityV2,
});

/**
 * A list of resource identities.
 */
export const vBatchGetRequest = v.object({
  libs: v.optional(v.array(vLibraryIdentity)),
  defs: v.optional(v.array(vDefinitionIdentityV2)),
  psets: v.optional(v.array(vPSetIdentity)),
});

/**
 * The response from batch get API. A map of responses, errors and unprocessed items.
 */
export const vBatchGetResponse = v.object({
  responses: v.object({
    libs: v.optional(v.array(vLibraryResponse)),
    defs: v.optional(v.array(vDefinitionResponse)),
    psets: v.optional(v.array(vPSetResponse)),
  }),
  unprocessed: v.object({
    libs: v.optional(v.array(vLibraryIdentity)),
    defs: v.optional(v.array(vDefinitionIdentityV2)),
    psets: v.optional(v.array(vPSetIdentity)),
  }),
  errors: v.object({
    libs: v.optional(v.array(vBatchGetLibraryError)),
    defs: v.optional(v.array(vBatchGetDefinitionsV2Error)),
    psets: v.optional(v.array(vBatchGetPSetError)),
  }),
});

/**
 * The property set changeset request.
 */
export const vChangesetRequest = v.object({
  items: v.array(vChangePSetRequest),
});

/**
 * The changeset accepted response.
 */
export const vChangesetResponseAccepted = v.object({
  id: v.string(),
  createdAt: v.pipe(v.string(), v.isoTimestamp()),
  createdBy: v.string(),
  status: v.string(),
});

/**
 * The changeset initiation response.
 */
export const vChangesetResponseInitiated = v.object({
  id: v.string(),
  createdAt: v.pipe(v.string(), v.isoTimestamp()),
  createdBy: v.string(),
  status: v.string(),
  uploadUrl: v.string(),
});

/**
 * The status of changeset processing.
 */
export const vChangesetResponse = v.object({
  id: v.string(),
  createdAt: v.pipe(v.string(), v.isoTimestamp()),
  createdBy: v.string(),
  startedAt: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  processedAt: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  status: v.string(),
  message: v.optional(v.string()),
  itemCount: v.optional(v.pipe(v.number(), v.integer())),
  errorCount: v.optional(v.pipe(v.number(), v.integer())),
  resultsUrl: v.optional(v.string()),
  errorsUrl: v.optional(v.string()),
});

/**
 * A error descriptor from the changeset API.
 */
export const vChangesetError = v.object({
  code: v.string(),
  message: v.string(),
  item: vPSetResponse,
});

/**
 * The property set changeset response.
 */
export const vChangesetResponseInline = v.object({
  id: v.string(),
  createdAt: v.pipe(v.string(), v.isoTimestamp()),
  createdBy: v.string(),
  startedAt: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  processedAt: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  status: v.string(),
  itemCount: v.optional(v.pipe(v.number(), v.integer())),
  errorCount: v.optional(v.pipe(v.number(), v.integer())),
  items: v.optional(v.array(vPSetResponse)),
  errors: v.optional(v.array(vChangesetError)),
});

/**
 * The policy statement.
 */
export const vPolicyStatement = v.object({
  id: v.optional(v.pipe(v.string(), v.minLength(1))),
  effect: v.string(),
  principal: v.object({
    any: v.optional(v.array(v.string())),
    all: v.optional(v.array(v.string())),
    notAny: v.optional(v.array(v.string())),
    notAll: v.optional(v.array(v.string())),
  }),
  action: v.object({
    any: v.optional(v.array(v.string())),
    all: v.optional(v.array(v.string())),
    notAny: v.optional(v.array(v.string())),
    notAll: v.optional(v.array(v.string())),
  }),
  resource: v.object({
    any: v.optional(v.array(v.string())),
    all: v.optional(v.array(v.string())),
    notAny: v.optional(v.array(v.string())),
    notAll: v.optional(v.array(v.string())),
  }),
});

/**
 * The policy.
 */
export const vPolicy = v.object({
  id: v.optional(v.pipe(v.string(), v.minLength(1))),
  version: v.optional(v.picklist(['2020-04-06'])),
  statements: v.optional(v.array(vPolicyStatement)),
});

export const vLandingPageData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

export const vXdomainData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

export const vSubscribeData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

/**
 * Subscribe info
 */
export const vSubscribeResponse = vNotificationSubscribeResponse;

export const vMeData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(
    v.object({
      refresh: v.optional(v.boolean()),
      all: v.optional(v.boolean()),
      wait: v.optional(v.boolean()),
    })
  ),
});

/**
 * User info
 */
export const vMeResponse = vUserClaims;

export const vGetLibraryPolicyData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    libId: v.string(),
  }),
  query: v.optional(
    v.object({
      deleted: v.optional(v.boolean()),
    })
  ),
});

/**
 * The policy
 */
export const vGetLibraryPolicyResponse = vPolicy;

export const vUpdateLibraryPolicyData = v.object({
  body: vPolicy,
  path: v.object({
    libId: v.string(),
  }),
  query: v.optional(
    v.object({
      deleted: v.optional(v.boolean()),
    })
  ),
});

/**
 * Success if the policy applied.
 */
export const vUpdateLibraryPolicyResponse = v.void();

export const vCreateLibraryData = v.object({
  body: vCreateLibraryRequest,
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

/**
 * The resource created.
 */
export const vCreateLibraryResponse = vUpsertLibraryResponse;

export const vDeleteLibraryData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    libId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
    })
  ),
});

/**
 * The library info
 */
export const vDeleteLibraryResponse = vLibraryResponse;

export const vGetLibraryData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    libId: v.string(),
  }),
  query: v.optional(
    v.object({
      deleted: v.optional(v.boolean()),
    })
  ),
});

/**
 * The library info
 */
export const vGetLibraryResponse = vLibraryResponse;

export const vUpsertLibraryData = v.object({
  body: vUpsertLibraryRequest,
  path: v.object({
    libId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

/**
 * Success with the updated library resulting state.
 */
export const vUpsertLibraryResponse2 = vUpsertLibraryResponse;

export const vListDefinitionsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    libId: v.string(),
  }),
  query: v.optional(
    v.object({
      top: v.optional(
        v.pipe(v.number(), v.integer(), v.minValue(0), v.maxValue(500))
      ),
      type: v.optional(v.string()),
      skiptoken: v.optional(v.string()),
    })
  ),
});

/**
 * List of resources
 */
export const vListDefinitionsResponse = vPSetDefsPage;

export const vCreateDefinitionData = v.object({
  body: vCreatePSetDefRequest,
  path: v.object({
    libId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * The resource created.
 */
export const vCreateDefinitionResponse = vDefinitionResponse;

export const vDeleteDefinitionData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    libId: v.string(),
    defId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
    })
  ),
});

/**
 * The pset definition info
 */
export const vDeleteDefinitionResponse = vDefinitionResponse;

export const vGetDefinitionData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    libId: v.string(),
    defId: v.string(),
  }),
  query: v.optional(
    v.object({
      deleted: v.optional(v.boolean()),
    })
  ),
});

/**
 * The pset definition info
 */
export const vGetDefinitionResponse = vDefinitionResponse;

export const vUpsertDefinitionData = v.object({
  body: vUpsertPSetDefRequest,
  path: v.object({
    libId: v.string(),
    defId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

/**
 * Success with the pset definition resulting state.
 */
export const vUpsertDefinitionResponse = vDefinitionResponse;

export const vListPSetsByLibData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    libId: v.string(),
  }),
  query: v.optional(
    v.object({
      top: v.optional(
        v.pipe(v.number(), v.integer(), v.minValue(0), v.maxValue(500))
      ),
      skiptoken: v.optional(v.string()),
    })
  ),
});

/**
 * List of resources
 */
export const vListPSetsByLibResponse = vSyncPSetsPage;

export const vListPSetsByDefData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    libId: v.string(),
    defId: v.string(),
  }),
  query: v.optional(
    v.object({
      sortBy: v.optional(v.picklist(['modifiedAt'])),
      link: v.optional(v.string()),
      top: v.optional(
        v.pipe(v.number(), v.integer(), v.minValue(0), v.maxValue(500))
      ),
      deleted: v.optional(v.boolean()),
      skiptoken: v.optional(v.string()),
    })
  ),
});

/**
 * List of resources
 */
export const vListPSetsByDefResponse = vSyncPSetsPage;

export const vBatchGetDefinitionsData = v.object({
  body: vDefinitionIdentityList,
  path: v.object({
    libId: v.string(),
  }),
  query: v.optional(
    v.object({
      deleted: v.optional(v.boolean()),
    })
  ),
});

/**
 * List of resources
 */
export const vBatchGetDefinitionsResponse2 = vBatchGetDefinitionsResponse;

export const vListDefinitionVersionsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    libId: v.string(),
    defId: v.string(),
  }),
  query: v.optional(
    v.object({
      deleted: v.optional(v.boolean()),
      top: v.optional(
        v.pipe(v.number(), v.integer(), v.minValue(0), v.maxValue(500))
      ),
      skiptoken: v.optional(v.string()),
    })
  ),
});

/**
 * The list of pset definition versions.
 */
export const vListDefinitionVersionsResponse = vPSetDefsPage;

export const vValidatePsetsData = v.object({
  body: vValidationRequest,
  path: v.object({
    libId: v.string(),
    defId: v.string(),
  }),
  query: v.optional(
    v.object({
      deleted: v.optional(v.boolean()),
    })
  ),
});

/**
 * The results of the validation with the count of valid and not valid pset instances.
 */
export const vValidatePsetsResponse = vValidationResponsePage;

export const vGetDefinitionVersionData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    libId: v.string(),
    defId: v.string(),
    ver: v.pipe(v.number(), v.integer()),
  }),
  query: v.optional(v.never()),
});

/**
 * The pset definition version.
 */
export const vGetDefinitionVersionResponse = vDefinitionResponse;

export const vGetDefinitionVersionBySchemaData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    libId: v.string(),
    defId: v.string(),
    ver: v.pipe(v.number(), v.integer()),
  }),
  query: v.optional(v.never()),
});

/**
 * The pset definition version.
 */
export const vGetDefinitionVersionBySchemaResponse = vDefinitionResponse;

export const vBatchGetData = v.object({
  body: vBatchGetRequest,
  path: v.optional(v.never()),
  query: v.optional(
    v.object({
      deleted: v.optional(v.boolean()),
    })
  ),
});

/**
 * The fetched resources.
 */
export const vBatchGetResponse2 = vBatchGetResponse;

export const vListPSetsOldData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.object({
    libId: v.string(),
    defId: v.string(),
    link: v.optional(v.string()),
    top: v.optional(
      v.pipe(v.number(), v.integer(), v.minValue(0), v.maxValue(500))
    ),
    deleted: v.optional(v.boolean()),
    skiptoken: v.optional(v.string()),
  }),
});

/**
 * List of resources
 */
export const vListPSetsOldResponse = vPSetsPage;

export const vBatchGetPSetsData = v.object({
  body: vPSetIdentityList,
  path: v.optional(v.never()),
  query: v.optional(
    v.object({
      deleted: v.optional(v.boolean()),
    })
  ),
});

/**
 * List of resources
 */
export const vBatchGetPSetsResponse2 = vBatchGetPSetsResponse;

export const vBatchGetPSetsByDefData = v.object({
  body: vLinkList,
  path: v.object({
    libId: v.string(),
    defId: v.string(),
  }),
  query: v.optional(
    v.object({
      deleted: v.optional(v.boolean()),
    })
  ),
});

/**
 * List of resources
 */
export const vBatchGetPSetsByDefResponse2 = vBatchGetPSetsByDefResponse;

export const vChangesetPSetsData = v.object({
  body: vChangesetRequest,
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

export const vChangesetPSetsResponse = v.union([
  vChangesetResponseInline,
  vChangesetResponseAccepted,
]);

export const vChangesetPSetsAsyncData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

/**
 * Changeset initialized and waiting for upload of the content
 */
export const vChangesetPSetsAsyncResponse = vChangesetResponseInitiated;

export const vGetChangesetStatusData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    cSetId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * Changeset status
 */
export const vGetChangesetStatusResponse = vChangesetResponse;

export const vListPsetsByLinkData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    link: v.string(),
  }),
  query: v.optional(
    v.object({
      top: v.optional(
        v.pipe(v.number(), v.integer(), v.minValue(0), v.maxValue(500))
      ),
      skiptoken: v.optional(v.string()),
      deleted: v.optional(v.boolean()),
    })
  ),
});

/**
 * List of resources
 */
export const vListPsetsByLinkResponse = vPSetsPage;

export const vDeletePSetData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    link: v.string(),
    libId: v.string(),
    defId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
    })
  ),
});

/**
 * The pset info
 */
export const vDeletePSetResponse = vPSetResponse;

export const vGetPSetData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    link: v.string(),
    libId: v.string(),
    defId: v.string(),
  }),
  query: v.optional(
    v.object({
      deleted: v.optional(v.boolean()),
    })
  ),
});

/**
 * The pset info
 */
export const vGetPSetResponse = vPSetResponse;

export const vUpdatePSetData = v.object({
  body: vUpdatePSetRequest,
  path: v.object({
    link: v.string(),
    libId: v.string(),
    defId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

/**
 * Success with the pset resulting state.
 */
export const vUpdatePSetResponse = vPSetResponse;

export const vListPSetVersionsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    link: v.string(),
    libId: v.string(),
    defId: v.string(),
  }),
  query: v.optional(
    v.object({
      deleted: v.optional(v.boolean()),
      top: v.optional(
        v.pipe(v.number(), v.integer(), v.minValue(0), v.maxValue(500))
      ),
      skiptoken: v.optional(v.string()),
    })
  ),
});

/**
 * The list of resources.
 */
export const vListPSetVersionsResponse = vPSetsPage;

export const vGetPSetVersionData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    link: v.string(),
    libId: v.string(),
    defId: v.string(),
    ver: v.pipe(v.number(), v.integer()),
  }),
  query: v.optional(v.never()),
});

/**
 * The pset version.
 */
export const vGetPSetVersionResponse = vPSetResponse;

export const vPsetsSyncData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    libId: v.string(),
    defId: v.string(),
  }),
  query: v.optional(
    v.object({
      top: v.optional(
        v.pipe(v.number(), v.integer(), v.minValue(0), v.maxValue(500))
      ),
      skiptoken: v.optional(v.string()),
    })
  ),
});

/**
 * List of resources
 */
export const vPsetsSyncResponse = vSyncPSetsPage;

export const vListPSetChangesByLibData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    libId: v.string(),
  }),
  query: v.object({
    changeToken: v.string(),
    top: v.optional(
      v.pipe(v.number(), v.integer(), v.minValue(0), v.maxValue(500))
    ),
    skiptoken: v.optional(v.string()),
  }),
});

/**
 * List of resources
 */
export const vListPSetChangesByLibResponse = vSyncPSetsPage;

export const vListPSetChangesByDefData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    libId: v.string(),
    defId: v.string(),
  }),
  query: v.object({
    changeToken: v.string(),
    top: v.optional(
      v.pipe(v.number(), v.integer(), v.minValue(0), v.maxValue(500))
    ),
    skiptoken: v.optional(v.string()),
  }),
});

/**
 * List of resources
 */
export const vListPSetChangesByDefResponse = vSyncPSetsPage;
